enum AIReviewCategoryStatus {
    // The initial state where the review for category has been requested but not yet started
    PENDING = "pending",
    // The review for category is currently being processed
    IN_PROGRESS = "in_progress",
    // The review for category was canceled by the user or system
    CANCELLED = "canceled",
    // The review for category has been completed successfully
    COMPLETED = "completed",
    // The review for category has been failed, no successful review for category
    FAILED = "failed",
}

export function compareStatuses(
    aStatus: AIReviewCategoryStatus,
    bStatus?: AIReviewCategoryStatus
): AIReviewCategoryStatus {
    if (aStatus === AIReviewCategoryStatus.CANCELLED || bStatus === AIReviewCategoryStatus.CANCELLED) {
        return AIReviewCategoryStatus.CANCELLED;
    }

    if (aStatus === AIReviewCategoryStatus.FAILED || bStatus === AIReviewCategoryStatus.FAILED) {
        return AIReviewCategoryStatus.FAILED;
    }

    if (aStatus === AIReviewCategoryStatus.PENDING || bStatus === AIReviewCategoryStatus.PENDING) {
        return AIReviewCategoryStatus.PENDING;
    }

    if (aStatus === AIReviewCategoryStatus.IN_PROGRESS || bStatus === AIReviewCategoryStatus.IN_PROGRESS) {
        return AIReviewCategoryStatus.IN_PROGRESS;
    }

    if (aStatus === AIReviewCategoryStatus.COMPLETED || bStatus === AIReviewCategoryStatus.COMPLETED) {
        return AIReviewCategoryStatus.COMPLETED;
    }

    return aStatus;
}

export default AIReviewCategoryStatus;
